module.exports = __webpack_public_path__ + "static/media/4.874b1e41.png";